module.exports = __webpack_public_path__ + "static/img/4-1.f25070c.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/4-1.png
// module id = 268
// module chunks = 0